import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询文档模版列表
export function getDocumentTemplateList(data) {
  return request({
    url: URL.sys.documentTemplateList,
    method: 'post',
    data
  })
}

// 新增文档模版
export function addDocumentTemplate(data) {
  return request({
    url: URL.sys.addDocumentTemplate,
    method: 'post',
    data
  })
}

// 编辑文档模版
export function editDocumentTemplate(data) {
  return request({
    url: URL.sys.editDocumentTemplate,
    method: 'post',
    data
  })
}

// 获取文档模版详情
export function getDocumentTemplateDetail(uuid) {
  return request({
    url: URL.sys.getDocumentTemplateDetail,
    method: 'get',
    params: { uuid }
  })
}

// 批量更新文档模版状态
export function batchUpdateDocumentTemplateStatus(data) {
  return request({
    url: URL.sys.batchUpdateDocumentTemplateStatus,
    method: 'post',
    data
  })
}

// 批量删除文档模版
export function batchDeleteDocumentTemplate(data) {
  return request({
    url: URL.sys.batchDeleteDocumentTemplate,
    method: 'post',
    data
  })
}
